import { Checkbox, FormControlLabel, Grid, Stack } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  formDetailsState,
  setIsTermsAndConditionsAccepted,
  setService,
  setTermsAndConditionsBase64String,
  StepBackward,
  StepForward,
} from '../../../../../store/slice/stepperSlice'
import {
  convertBase64ToHtml,
  executeWithTryCatch,
  gettingCompanyId,
  normalizeApiResponse,
} from '../../../../../helpers/HelperFunctions'
import nextbtn from '../../../../../assets/icons/Next Button.svg'
import backbtn from '../../../../../assets/icons/Back Button.svg'
import { useToastContext } from '../../../../../App'
import { TOAST_MESSAGES } from '../../../../../helpers/Constants'
import { getCompanyNameStepper } from '../../../../../api/get/getApi'
import { useCommonRedux } from '../../../../../store/middlewares/CommonRedux'
import { setSkeletonLoading } from '../../../../../store/slice/commonSlice'
import SkeletonTableLoader from '../../../../../common/components/loaders/skeletonLoader'
import { BorderBox } from '../../../../../common/styles/styled-components/StyledContainers'

const ConsentAndAcknowledgement = () => {
  const { dispatch, state: commonState } = useCommonRedux()
  const { toast } = useToastContext()
  const stepperState = useSelector(formDetailsState)
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false)
  const contentRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setIsScrolledToBottom(true)
      }
    }

    const currentRef = contentRef.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])
  useEffect(() => {
    if (!stepperState.termsAndConditionBase64String) {
      executeWithTryCatch(getCompanyDraft, handleError)
    }
  }, [])

  const getCompanyDraft = async () => {
    dispatch(setSkeletonLoading(true))
    const localToken = localStorage.getItem('sd_cp.jwt:tkn')
    const config = { headers: { Authorization: `Bearer ${localToken}` } }
    const {
      data: { result },
    } = await getCompanyNameStepper(gettingCompanyId(), config)
    dispatch(setService(result?.service))
    dispatch(
      setTermsAndConditionsBase64String(result?.termsAndConditionsFileData)
    )
    dispatch(
      setIsTermsAndConditionsAccepted(result?.isTermsAndConditionsAccepted)
    )
    dispatch(setSkeletonLoading(false))
  }

  //Error
  const handleError = (error) => {
    dispatch(setSkeletonLoading(false))
    toast.showToast(normalizeApiResponse(error)?.message, 'error')
  }

  const handleAcceptTermsAndCondition = (e) =>
    dispatch(setIsTermsAndConditionsAccepted(e.target.checked))

  const handleSubmitTermsAndCondition = () => {
    if (stepperState.isTermsAndConditionsAccepted) {
      dispatch(StepForward())
    } else {
      toast.showToast(TOAST_MESSAGES.AcceptTermsAndCondition, 'error')
    }
  }

  return (
    <Grid container sx={{ display: 'flex' }}>
      {stepperState?.termsAndConditionBase64String && (
        <BorderBox>
          {commonState?.isSkeletonLoading ? (
            <SkeletonTableLoader />
          ) : (
            <div
              ref={contentRef}
              style={{
                padding: 1,
                height: '75vh',
                width: '100%',
                overflowY: 'scroll',
              }}
            >
              {convertBase64ToHtml(stepperState?.termsAndConditionBase64String)}
            </div>
          )}
        </BorderBox>
      )}

      <Grid item md={12} sm={12} xs={12} sx={{ paddingLeft: '10px' }}>
        <FormControlLabel
          onChange={handleAcceptTermsAndCondition}
          control={
            <Checkbox
              defaultChecked={stepperState.isTermsAndConditionsAccepted}
              disabled={
                !isScrolledToBottom &&
                !stepperState.isTermsAndConditionsAccepted
              }
            />
          }
          label="I Agree"
        />
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <Stack direction="row" justifyContent="flex-start">
          <img
            src={backbtn}
            className="btn-hover-effect"
            height="92px"
            onClick={() => {
              dispatch(StepBackward())
            }}
            alt="next button"
          />
          <img
            src={nextbtn}
            className="btn-hover-effect"
            height="92px"
            onClick={handleSubmitTermsAndCondition}
            alt="next button"
          />
        </Stack>
      </Grid>
    </Grid>
  )
}

export default ConsentAndAcknowledgement
